'use strict';

exports.__esModule = true;
exports.PracticeReviewsContainer = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _find2 = require('lodash/find');

var _find3 = _interopRequireDefault(_find2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _style = require('../../src/styles/style.scss');

var _style2 = _interopRequireDefault(_style);

var _reactTransitionGroup = require('react-transition-group');

var _review = require('review');

var _widgetCarousel = require('widget-carousel');

var _peerRecommendation = require('peer-recommendation');

var _constants = require('../utils/constants');

var _utils = require('../utils/utils');

var _reactAnimations = require('react-animations');

var _radium = require('radium');

var _radium2 = _interopRequireDefault(_radium);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var babelPluginFlowReactPropTypes_proptype_WidgetState = require('../reducers/widget-reducers').babelPluginFlowReactPropTypes_proptype_WidgetState || require('react').PropTypes.any;

var dynamics = {
	fadeIn: {
		animation: 'x 1s',
		animationName: _radium2.default.keyframes(_reactAnimations.fadeIn, 'fadeIn')
	}
};

var _ref = _react2.default.createElement(
	'div',
	{ key: 'no practice to show' },
	'No Practice reviews to show'
);

var _ref2 = _react2.default.createElement(
	'div',
	null,
	'No Specialist reviews to show'
);

var _ref3 = _react2.default.createElement(
	'div',
	null,
	'No Specialists reviews to show'
);

var _ref4 = _react2.default.createElement(
	'div',
	{ key: 0 },
	'No Peer Recommendations to show for that specialist'
);

var _ref5 = _react2.default.createElement(
	'div',
	{ key: 1 },
	'No Peer Recommendations to show for that practice'
);

var PracticeReviewsContainer = exports.PracticeReviewsContainer = function PracticeReviewsContainer(props) {
	if (!props.widget || !props.header || !props.carousel) {
		throw new Error('Missing one reducer!');
	}
	var selectedSpecialist = (0, _utils.getSelectedSpecialist)(props.carousel.selectedSpecialist, props.widget.specialists);
	return _react2.default.createElement(
		_radium.StyleRoot,
		null,
		_react2.default.createElement(
			'div',
			{ className: _style2.default.widgetCarousel + ' ' + (props.widget && props.widget.disableTabs ? '' : _style2.default.tabs) },
			_react2.default.createElement('div', { className: _style2.default.hidden + ' ' + ((0, _utils.showTabContent)(props, _constants.PRACTICE_TAB) && _style2.default.practiceReviewsHolder || (0, _utils.showTabContent)(props, _constants.SPECIALISTS_REVIEWS_TAB) && (!props.carousel.selectedSpecialist || props.carousel.selectedSpecialist.id === 'all') && _style2.default.specialistsReviewsHolder || (0, _utils.showTabContent)(props, _constants.SPECIALISTS_REVIEWS_TAB) && props.carousel.selectedSpecialist && props.carousel.selectedSpecialist.id !== 'all' && _style2.default.specialistReviewsHolder || (0, _utils.showTabContent)(props, _constants.SPECIALISTS_RECOMMENDATIONS_TAB) && (!props.carousel.selectedSpecialist || props.carousel.selectedSpecialist.id === 'all') && _style2.default.specialistsRecommendationsHolder || (0, _utils.showTabContent)(props, _constants.SPECIALISTS_RECOMMENDATIONS_TAB) && props.carousel.selectedSpecialist && props.carousel.selectedSpecialist.id !== 'all' && _style2.default.specialistRecommendationsHolder) }),
			_react2.default.createElement(
				_reactTransitionGroup.Transition,
				{ 'in': (0, _utils.showTabContent)(props, _constants.PRACTICE_TAB), timeout: 500 },
				function (state) {
					return _react2.default.createElement(
						'div',
						{ style: (0, _utils.getTransition)(props)[state], className: '' + _style2.default.transition },
						_react2.default.createElement(
							_widgetCarousel.WidgetCarousel,
							{
								title: 'Reviews',
								subtitle: 'about our practice',
								isLoading: props.widget.isLoading,
								rowSize: (0, _utils.getRowSize)(props.widget && props.widget.layoutType),
								showNextButton: props.widget.practice && props.carousel.practiceReviewsOffset < props.widget.practice.numberOfReviews - _constants.CAROUSEL_LENGTH,
								showPreviousButton: props.carousel.practiceReviewsOffset > 0,
								onNextButtonClick: function onNextButtonClick() {
									props.carouselActions.updateOffset({ practiceReviewsOffset: props.carousel.practiceReviewsOffset + _constants.CAROUSEL_LENGTH });
									props.widgetActions.getReviews(props.location && props.location.query && props.location.query.profileId, {
										offset: props.carousel.practiceReviewsOffset + _constants.CAROUSEL_LENGTH,
										limit: _constants.CAROUSEL_LENGTH,
										min_rating: props.widget.minReviewRating
									});
								},
								onPreviousButtonClick: function onPreviousButtonClick() {
									props.carouselActions.updateOffset({ practiceReviewsOffset: props.carousel.practiceReviewsOffset - _constants.CAROUSEL_LENGTH });
									props.widgetActions.getReviews(props.location && props.location.query && props.location.query.profileId, {
										offset: props.carousel.practiceReviewsOffset - _constants.CAROUSEL_LENGTH,
										limit: _constants.CAROUSEL_LENGTH,
										min_rating: props.widget.minReviewRating
									});
								},
								profileType: 'practice',
								contentType: 'reviews',
								averageRating: props.widget.practice && props.widget.practice.averageReviews,
								totalReviews: props.widget.practice && props.widget.practice.numberOfReviews
							},
							props.widget.practiceReviews && props.widget.practiceReviews.length ? props.widget.practiceReviews.map(function (review, index) {
								return _react2.default.createElement(
									'div',
									{ key: 'review-' + props.carousel.practiceReviewsOffset + '-' + index, style: dynamics.fadeIn },
									_react2.default.createElement(_review.Review, (0, _extends3.default)({
										disableLikeButton: true,
										className: '' + _style2.default.review,
										titleStyle: _style2.default.title,
										reviewContentStyle: _style2.default.reviewContent,
										body: review.body
									}, review))
								);
							}) : [_ref]
						)
					);
				}
			),
			_react2.default.createElement(
				_reactTransitionGroup.Transition,
				{ 'in': (0, _utils.showTabContent)(props, _constants.SPECIALISTS_REVIEWS_TAB), timeout: 500 },
				function (state) {
					return _react2.default.createElement(
						'div',
						{ style: (0, _utils.getTransition)(props)[state], className: '' + _style2.default.transition },
						_react2.default.createElement(
							_widgetCarousel.WidgetCarousel,
							{
								title: 'Reviews',
								subtitle: 'about ' + (selectedSpecialist && selectedSpecialist.name || 'our doctors'),
								isLoading: props.widget.isLoading,
								rowSize: (0, _utils.getRowSize)(props.widget && props.widget.layoutType),
								showNextButton: props.carousel.specialistsReviewsOffset < ((!props.carousel.selectedSpecialist || props.carousel.selectedSpecialist.id === 'all') && props.widget.specialistsReviewsCount || selectedSpecialist && selectedSpecialist.numberOfReviews) - _constants.CAROUSEL_LENGTH,
								showPreviousButton: props.carousel.specialistsReviewsOffset > 0,
								onNextButtonClick: function onNextButtonClick() {
									var id = props.carousel.selectedSpecialist && props.carousel.selectedSpecialist.id === 'all' ? props.location && props.location.query && props.location.query.profileId : props.carousel.selectedSpecialist.id;
									props.carouselActions.updateOffset({ specialistsReviewsOffset: props.carousel.specialistsReviewsOffset + _constants.CAROUSEL_LENGTH });
									if (props.carousel.selectedSpecialist && props.carousel.selectedSpecialist.id === 'all') {
										props.widgetActions.getSpecialistsReviews(id, {
											offset: props.carousel.specialistsReviewsOffset + _constants.CAROUSEL_LENGTH,
											limit: _constants.CAROUSEL_LENGTH,
											min_rating: props.widget.minReviewRating
										});
									} else {
										props.widgetActions.getSpecialistReviews(id, _constants.PRACTICE_PROFILE_TYPE, {
											offset: props.carousel.specialistsReviewsOffset + _constants.CAROUSEL_LENGTH,
											limit: _constants.CAROUSEL_LENGTH,
											min_rating: props.widget.minReviewRating
										});
									}
								},
								onPreviousButtonClick: function onPreviousButtonClick() {
									var id = props.carousel.selectedSpecialist && props.carousel.selectedSpecialist.id === 'all' ? props.location && props.location.query && props.location.query.profileId : props.carousel.selectedSpecialist.id;
									props.carouselActions.updateOffset({ specialistsReviewsOffset: props.carousel.specialistsReviewsOffset - _constants.CAROUSEL_LENGTH });
									if (props.carousel.selectedSpecialist && props.carousel.selectedSpecialist.id === 'all') {
										props.widgetActions.getSpecialistsReviews(id, {
											offset: props.carousel.specialistsReviewsOffset - _constants.CAROUSEL_LENGTH,
											limit: _constants.CAROUSEL_LENGTH,
											min_rating: props.widget.minReviewRating
										});
									} else {
										props.widgetActions.getSpecialistReviews(id, _constants.PRACTICE_PROFILE_TYPE, {
											offset: props.carousel.specialistsReviewsOffset - _constants.CAROUSEL_LENGTH,
											limit: _constants.CAROUSEL_LENGTH,
											min_rating: props.widget.minReviewRating
										});
									}
								},
								totalReviews: (!props.carousel.selectedSpecialist || props.carousel.selectedSpecialist.id === 'all') && props.widget.specialistsReviews && props.widget.specialistsReviewsCount || selectedSpecialist && selectedSpecialist.numberOfReviews,
								averageRating: selectedSpecialist && selectedSpecialist.averageRating,
								showSpecialistRating: props.carousel.selectedSpecialist && props.carousel.selectedSpecialist.id !== 'all',
								profileType: 'specialist',
								contentType: 'reviews',
								dropdownItems: [{ name: 'all specialists', id: 'all' }].concat(props.widget.specialists && props.widget.specialists.filter(function (specialist) {
									return specialist.numberOfReviews;
								}).filter(function (specialist) {
									return props.carousel.filter && props.carousel.filter.length ? (specialist.name || '').toLowerCase().includes(props.carousel.filter.toLowerCase()) : specialist;
								})),
								onSpecialistSelected: function onSpecialistSelected(item) {
									props.carouselActions.selectSpecialist(item);
									props.carouselActions.setFilter();
									props.carouselActions.updateOffset({ specialistsReviewsOffset: 0 });
									if (item.id !== 'all') {
										props.widgetActions.getSpecialistReviews(item.id, _constants.PRACTICE_PROFILE_TYPE, { offset: 0, limit: _constants.CAROUSEL_LENGTH, min_rating: props.widget.minReviewRating });
									}
								},
								selectedSpecialist: props.carousel.selectedSpecialist || { name: 'all specialists', id: 'all' },
								onSpecialistTextChanged: props.carouselActions.setFilter
							},
							selectedSpecialist && selectedSpecialist.reviews ? selectedSpecialist.reviews.map(function (review, index) {
								return _react2.default.createElement(
									'div',
									{ key: 'review-' + props.carousel.specialistsReviewsOffset + '-' + review.profileId + '-' + index, style: dynamics.fadeIn },
									_react2.default.createElement(_review.Review, (0, _extends3.default)({
										disableLikeButton: true,
										className: '' + _style2.default.review,
										titleStyle: _style2.default.title,
										reviewContentStyle: _style2.default.reviewContent,
										style: dynamics.fadeIn
									}, review, (0, _find3.default)(props.widget.specialists, function (specialist) {
										return specialist.id === props.carousel.selectedSpecialist && props.carousel.selectedSpecialist.id;
									})))
								);
							}) : [_ref2] || props.widget.specialistsReviews ? props.widget.specialistsReviews.map(function (review, index) {
								return _react2.default.createElement(
									'div',
									{ key: 'review-' + props.carousel.specialistsReviewsOffset + '-' + index, style: dynamics.fadeIn },
									_react2.default.createElement(_review.Review, (0, _extends3.default)({
										disableLikeButton: true,
										titleStyle: _style2.default.title,
										style: dynamics.fadeIn,
										reviewContentStyle: _style2.default.reviewContent
									}, review, {
										profileName: ((0, _utils.getSelectedSpecialist)({ id: review.profileId }, props.widget.specialists) || {}).name
									}, selectedSpecialist, {
										className: '' + _style2.default.review
									}))
								);
							}) : [_ref3]
						)
					);
				}
			),
			_react2.default.createElement(
				_reactTransitionGroup.Transition,
				{ 'in': (0, _utils.showTabContent)(props, _constants.SPECIALISTS_RECOMMENDATIONS_TAB), timeout: 500 },
				function (state) {
					return _react2.default.createElement(
						'div',
						{ style: (0, _utils.getTransition)(props)[state], className: '' + _style2.default.transition },
						_react2.default.createElement(
							_widgetCarousel.WidgetCarousel,
							{
								title: 'Recommendations',
								subtitle: 'about ' + (selectedSpecialist && selectedSpecialist.name || 'our doctors'),
								isLoading: props.widget.isLoading,
								rowSize: (0, _utils.getRowSize)(props.widget && props.widget.layoutType),
								showNextButton: props.carousel.specialistsRecommendationsOffset < ((!props.carousel.selectedSpecialist || props.carousel.selectedSpecialist.id === 'all') && props.widget.specialistsPeerRecommendationsCount || selectedSpecialist && selectedSpecialist.numberOfPeerRecommendations) - _constants.CAROUSEL_LENGTH,
								showPreviousButton: props.carousel.specialistsRecommendationsOffset > 0,
								onNextButtonClick: function onNextButtonClick() {
									var id = props.carousel.selectedSpecialist && props.carousel.selectedSpecialist.id === 'all' ? props.location && props.location.query && props.location.query.profileId : props.carousel.selectedSpecialist.id;
									props.carouselActions.updateOffset({ specialistsRecommendationsOffset: props.carousel.specialistsRecommendationsOffset + _constants.CAROUSEL_LENGTH });
									if (props.carousel.selectedSpecialist && props.carousel.selectedSpecialist.id === 'all') {
										props.widgetActions.getSpecialistsPeerRecommendations(id, {
											offset: props.carousel.specialistsRecommendationsOffset + _constants.CAROUSEL_LENGTH,
											limit: _constants.CAROUSEL_LENGTH
										});
									} else {
										props.widgetActions.getSpecialistsPeerRecommendations(id, _constants.PRACTICE_PROFILE_TYPE, {
											offset: props.carousel.specialistsRecommendationsOffset + _constants.CAROUSEL_LENGTH,
											limit: _constants.CAROUSEL_LENGTH
										});
									}
								},
								onPreviousButtonClick: function onPreviousButtonClick() {
									var id = props.carousel.selectedSpecialist && props.carousel.selectedSpecialist.id === 'all' ? props.location && props.location.query && props.location.query.profileId : props.carousel.selectedSpecialist.id;
									props.carouselActions.updateOffset({ specialistsRecommendationsOffset: props.carousel.specialistsRecommendationsOffset - _constants.CAROUSEL_LENGTH });
									if (props.carousel.selectedSpecialist && props.carousel.selectedSpecialist.id === 'all') {
										props.widgetActions.getSpecialistsPeerRecommendations(id, {
											offset: props.carousel.specialistsRecommendationsOffset - _constants.CAROUSEL_LENGTH,
											limit: _constants.CAROUSEL_LENGTH
										});
									} else {
										props.widgetActions.getSpecialistsPeerRecommendations(id, _constants.PRACTICE_PROFILE_TYPE, {
											offset: props.carousel.specialistsRecommendationsOffset - _constants.CAROUSEL_LENGTH,
											limit: _constants.CAROUSEL_LENGTH
										});
									}
								},
								showSpecialistRating: false,
								profileType: 'specialist',
								contentType: 'recommendations',
								selectedSpecialist: props.carousel.selectedSpecialist || { name: 'all specialists', id: 'all' },
								totalReviews: (!props.carousel.selectedSpecialist || props.carousel.selectedSpecialist.id === 'all') && props.widget.specialistsPeerRecommendationsCount || selectedSpecialist && selectedSpecialist.numberOfPeerRecommendations,
								dropdownItems: [{ name: 'all', id: 'all' }].concat(props.widget.specialists && props.widget.specialists.filter(function (specialist) {
									return specialist.numberOfPeerRecommendations;
								}).filter(function (specialist) {
									return props.carousel.filter && props.carousel.filter.length ? (specialist.name || '').toLowerCase().includes(props.carousel.filter.toLowerCase()) : specialist;
								})),
								onSpecialistSelected: function onSpecialistSelected(item) {
									props.carouselActions.selectSpecialist(item);
									props.carouselActions.setFilter();
									props.carouselActions.updateOffset({ specialistsRecommendationsOffset: 0 });
									if (item.id !== 'all') {
										props.widgetActions.getSpecialistPeerRecommendations(item.id, _constants.PRACTICE_PROFILE_TYPE, { offset: 0, limit: _constants.CAROUSEL_LENGTH });
									}
								},
								onSpecialistTextChanged: props.carouselActions.setFilter
							},
							selectedSpecialist && selectedSpecialist.peerRecommendations && selectedSpecialist.peerRecommendations.map(function (peerRecommendation, index) {
								return _react2.default.createElement(
									'div',
									{ key: 'recommendation-' + props.carousel.specialistRecommendationsOffset + '-' + peerRecommendation.recommendeeId + '-' + index, style: dynamics.fadeIn },
									_react2.default.createElement(_peerRecommendation.PeerRecommendation, (0, _extends3.default)({
										className: '' + _style2.default.review,
										titleStyle: _style2.default.title,
										style: dynamics.fadeIn,
										recommendationContentStyle: _style2.default.reviewContent
									}, peerRecommendation))
								);
							}) || selectedSpecialist && [_ref4] || props.widget.specialistsPeerRecommendations && props.widget.specialistsPeerRecommendations.map(function (peerRecommendation, index) {
								return _react2.default.createElement(
									'div',
									{ key: 'recommendation-' + props.carousel.specialistsRecommendationsOffset + '-' + index, style: dynamics.fadeIn },
									_react2.default.createElement(_peerRecommendation.PeerRecommendation, (0, _extends3.default)({
										style: dynamics.fadeIn,
										className: '' + _style2.default.review,
										titleStyle: _style2.default.title,
										recommendeeName: peerRecommendation.recommendeeName,
										recommendationContentStyle: _style2.default.reviewContent
									}, peerRecommendation))
								);
							}) || [_ref5]
						)
					);
				}
			)
		)
	);
};

PracticeReviewsContainer.propTypes = {
	testString: require('react').PropTypes.any,
	widget: babelPluginFlowReactPropTypes_proptype_WidgetState,
	carousel: require('react').PropTypes.shape({
		selectedSpecialistId: require('react').PropTypes.any
	}).isRequired,
	header: require('react').PropTypes.shape({
		selectedIndex: require('react').PropTypes.any.isRequired
	}).isRequired
};
PracticeReviewsContainer.displayName = 'PracticeReviewsContainer';

PracticeReviewsContainer.defaultProps = {};